import React from 'react';
import { Table } from 'react-bootstrap';
import ServiceItem from './ServiceItem'

class ServiceList extends React.Component {

    onPing = (serviceName) => {
        this.props.onPing(serviceName)
    };

    render() {
        const List = this.props.services.map((item) => {
            // Find ping
            const ping = this.props.pings.find(function (service) { return (service.serviceName === item.serviceName) });

            // No ping?
            if (ping === undefined) {
                return (<ServiceItem
                    key={item.serviceName}
                    serviceName={item.serviceName}
                    url={item.url} />);
            }

            return (<ServiceItem
                key={item.serviceName}
                serviceName={item.serviceName}
                url={item.url}
                serverName={ping.serverName}
                startupDate={ping.startupDate}
                environmentCode={ping.environmentCode}
                version={ping.version}
                processing={ping.processing}
                checks={ping.checks}
                pingError={ping.pingError}
                onPing={this.onPing} />)
        });

        return (
            <div>
                <Table responsive>
                    <thead>
                        <tr>
                            <th>
                                Service
                            </th>
                            <th>
                                Server
                            </th>
                            <th>
                                Environment
                            </th>
                            <th>
                                Checks
                            </th>
                            <th>
                                Status
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {List}
                    </tbody>
                </Table>
            </div>
        )
    }
}

export default ServiceList;


// WEBPACK FOOTER //
// ./src/areas/admin/console/services/ServiceList.js